const TAG_BLOCKLIST = ['NEXTJS-PORTAL', 'MAIN', 'BODY'];
const CLASS_BLOCKLIST = [
    'vds-container',
    'vds-nav-main--desktop',
    'vds-nav-main--mobile',
    'vds-footer',
    'vds-screen',
    'PageLayout',
    'vds-container',
    // SearchBar suggestion chips fire their own explicit tracking
    // (tracksuggestedsearchresultused) on select; exclude them from generic
    // click auto-tracking to avoid duplicate events.
    //
    // NOTE: this couples to the VDS SearchBar internal class (`@vds/components`
    // SearchBar -> `.vds-search-bar__chip`). The chip renders as a single
    // <button> whose only child is the suggestion text, so matching the
    // target's own class is sufficient (the click target is always the button).
    // If VDS renames this class, sync this entry.
    'vds-search-bar__chip',
];

// Check if the target has a class that is in the blocklist
const isValidClass = (target: HTMLElement) => {
    const classList = target.classList;
    return !Array.from(classList).some((className) => {
        for (const blockClass of CLASS_BLOCKLIST) {
            if (className.includes(blockClass)) {
                return true;
            }
        }
    });
};

/* @target html element
 * takes in a click event element target and makes sure it's a valid tracking tag
 */
const checkValidElement = (target: HTMLElement) => {
    // Skip tracking if data-auto-tracking is set on the target for custom
    const preventAutoTracking = target?.getAttribute('data-prevent-auto-tracking');
    return (
        target &&
        !TAG_BLOCKLIST.includes(target?.tagName) &&
        !preventAutoTracking &&
        isValidClass(target)
    );
};

export { checkValidElement };
